import { diContainer, serviceNames } from '../diContainer/diContainer';
import Transaction from '../domain/entities/Transaction/Transaction';
import ShippingUIState from '../stores/UIState/ShippingUIState';
import TransactionRepository from '../repositories/TransactionRepository';
import { DeliveryOptions } from '../constants/Constants';

export default class CheckTransactionBreakingMissingData {
  private shippingUIState: ShippingUIState;

  private transactionRepository: TransactionRepository;

  constructor() {
    this.shippingUIState = diContainer.get(serviceNames.shippingUIState);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
  }

  public async execute(): Promise<void> {
    this.restorDefaults();
    await this.checkDataLoaded();
  }

  private restorDefaults(): void {
    this.shippingUIState.restoreDefaults();
  }

  private async checkDataLoaded(): Promise<void> {
    const transaction = await this.transactionRepository.getTransaction();
    this.checkShippingMethods(transaction);
  }

  private checkShippingMethods(transaction: Transaction): void {
    let isHomeShippingMethodMissing: boolean;
    if (transaction.isShippingV2Enabled) {
      // TODO RCO-10766 probably the correct check should apply to all/any of the delivery options, not just HOME, keeping same logic for now
      isHomeShippingMethodMissing = !transaction.deliveryOptions2
        ?.find(delivery => delivery.name === DeliveryOptions.HOME_DELIVERY).shipMethods?.length;
    } else {
      isHomeShippingMethodMissing = !transaction.shippingMethods?.items?.length;
    }
    const isFailed = transaction.isTransactionLoaded && isHomeShippingMethodMissing;
    this.shippingUIState.updateisShippingMethodsMissing(isFailed);
  }
}